import React from 'react';
import { Link } from 'components/link/Link';

import s from './ImageList.scss';

interface IProps {
  link?: string;
  children: React.ReactNode;
}

export const ImageListItem = ({ children, link }: IProps) => {
  console.log('link :>> ', link);
  const Container = Boolean(link) ? Link : React.Fragment;
  const containerProps = link ? { className: s.imageListItem__link, to: link } : {};

  return <Container {...containerProps}>{children}</Container>;
};
